import React from "react";
import { DisplayBox, InputBox, Loading } from "../../components";
import { ApiHelper, CommissionCheckInterface, DateHelper, UserHelper } from "../../helpers";
import { Redirect } from "react-router-dom";
import { Col, FormControl, Row } from "react-bootstrap";

interface Props {
  id: number
}


export const CommissionCheckDetails: React.FC<Props> = props => {

  const [check, setCheck] = React.useState<CommissionCheckInterface>(null);
  const [redirect, setRedirect] = React.useState("");
  const [editCheck, setEditCheck] = React.useState(false);

  const init = async () => {
    ApiHelper.get("/commissionChecks/" + props.id).then(d => setCheck(d));
  }

  const handleSave = () => {
    ApiHelper.post("/commissionChecks", [check]).then(() => { setRedirect("/settings/affiliate"); })
  }

  const handleDelete = () => {
    if (window.confirm("Are you sure you wish to delete this check?  All assigned commissions will return to unassigned.")) {
      ApiHelper.delete("/commissionChecks/" + props.id).then(() => { setRedirect("/settings/affiliate"); })
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let c: CommissionCheckInterface = { ...check };
    let val = e.currentTarget.value;
    switch (e.currentTarget.id) {
      case "paymentDate": c.paymentDate = DateHelper.convertToDate(val); break;
    }
    setCheck(c);
  }

  React.useEffect(() => { init() }, []); //eslint-disable-line

  if (redirect !== "") return <Redirect to={redirect} />
  else if (!check) return <Loading />
  else {
    let result = <></>;
    const d = DateHelper.convertToDateOnly(check.paymentDate);
    const formatter = Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });

    if (editCheck) {
      const paymentDateString = (check?.paymentDate) ? DateHelper.formatHtml5Date(DateHelper.convertToDateOnly(check.paymentDate)) : "";
      result = (<InputBox headerIcon="fas fa-money-bill-wave" headerText="Check Details" saveFunction={handleSave} deleteFunction={handleDelete}>
        <FormControl id="paymentDate" value={paymentDateString} onChange={handleChange} type="date" />
      </InputBox>);
    } else {
      const admin = UserHelper.checkAccess("admin");
      result = (<DisplayBox headerIcon="fas fa-money-bill-wave" headerText="Check Details" editFunction={(admin) ? () => { setEditCheck(true) } : null}>
        <Row>
          <Col><b>Date:</b> {DateHelper.formatDateTime(d, "MMM d yyyy")}</Col>
          <Col><b>Amount:</b> {formatter.format(check.totalAmount)}</Col>
        </Row>
      </DisplayBox>);
    }
    return result;

  }
};